import L from 'leaflet';
import type { TileLayer } from 'leaflet';

export function initMap(defaultLayer?: TileLayer) {
    const map = L.map('map', {
        center: [-36.83333, 175], // Metric Home Waypoint
        // center: [-41.2, 174.7],
        zoom: 12,
        maxZoom: 25,
        layers: defaultLayer ? [defaultLayer] : []
    });

    // Create a custom pane for overlays that should always be on top of base layers (like charts)
    map.createPane('topTilePane');
    map.getPane('topTilePane')!.style.zIndex = '300';
    // Ensure pointer events work
    map.getPane('topTilePane')!.style.pointerEvents = 'none';

    return map;
}
